<template>
    <div>
        <b-table-simple
            :id="`table-${sub_code}-structure-${content_index}`"
            :class="[{'border-none': is_element}, {'mb-4': is_element}]"
            bordered
            >
            <b-thead>
                <b-tr>
                    <b-th colspan="2">
                        sub_type: Table
                    </b-th>
                </b-tr>
                <template v-if="!has_table_title.kr && !has_sub_data_table_header.kr">
                    <b-tr>
                        <b-th class="text-nowrap"> 행 인덱스 </b-th>
                        <b-th> 편집 컨텐츠 </b-th>
                    </b-tr>
                </template>
            </b-thead>
            <template v-if="has_table_title.kr || has_sub_data_table_header.kr">
                <b-tbody>
                    <template v-if="has_table_title.kr">
                        <b-tr>
                            <b-td colspan="2">
                                <b-row>
                                    <b-col cols="12">
                                        <div class="d-flex align-items-center justify-content-between mb-3">
                                            <h6 class="mb-0">테이블 타이틀</h6>
                                            <b-btn
                                                variant="primary" size="sm"
                                                :disabled="(!has_table_title.ea && !has_table_title.ca) || !is_edited_table_title"
                                                @click="emitEditedTableHeaderTitle"
                                                >
                                                저장
                                            </b-btn>
                                        </div>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-row>
                                            <b-col cols="12">
                                                <template v-if="!has_table_title.kr">
                                                    <div class="d-flex align-items-center justify-content-center p-4 bgray-200">
                                                        <h6 class="font-italic gray-500 mb-0">(없음)</h6>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <b-form-group
                                                        :id="`fieldset-${sub_code}-table-table_title`"
                                                        label-cols-sm="2"
                                                        content-cols-sm
                                                        content-cols-lg="10"
                                                        label="(국문)"
                                                        :label-for="`input-sub-${sub_code}-table-table_title-kr`"
                                                        >
                                                        <b-form-input
                                                            :id="`input-sub-${sub_code}-table-table_title-kr`"
                                                            v-model="editable_sub_data.table_title"
                                                            disabled
                                                            />
                                                    </b-form-group>
                                                    <b-form-group
                                                        :id="`fieldset-${sub_code}-table-table_title`"
                                                        label-cols-sm="2"
                                                        content-cols-sm
                                                        content-cols-lg="10"
                                                        label="(중문)"
                                                        :label-for="`input-sub-${sub_code}-table-table_title-ca`"
                                                        >
                                                        <b-input-group>
                                                            <b-form-input
                                                                :id="`input-sub-${sub_code}-table-table_title-ca`"
                                                                v-model="editable_sub_data.table_title_ca"
                                                                @input="chageEditingTableTitle"
                                                                :disabled="isFieldEmpty(editable_sub_data.table_title)"
                                                                />
                                                            <template #append>
                                                                <b-btn variant="warning" size="sm"
                                                                    @click="generateTempTranslation(editable_sub_data.table_title, 'ca')"
                                                                    :disabled="isFieldEmpty(editable_sub_data.table_title)">
                                                                    <BIconTranslate />
                                                                </b-btn>
                                                            </template>
                                                        </b-input-group>
                                                    </b-form-group>
                                                    <b-form-group
                                                        :id="`fieldset-${sub_code}-table-table_title`"
                                                        label-cols-sm="2"
                                                        content-cols-sm
                                                        content-cols-lg="10"
                                                        label="(영문)"
                                                        :label-for="`input-sub-${sub_code}-table-table_title-ea`"
                                                        >
                                                        <b-input-group>
                                                            <b-form-input
                                                                :id="`input-sub-${sub_code}-table-table_title-ea`"
                                                                v-model="editable_sub_data.table_title_ea"
                                                                @input="chageEditingTableTitle"
                                                                :disabled="isFieldEmpty(editable_sub_data.table_title)"
                                                                />
                                                            <template #append>
                                                                <b-btn variant="warning" size="sm"
                                                                    @click="generateTempTranslation(editable_sub_data.table_title, 'ea')"
                                                                    :disabled="isFieldEmpty(editable_sub_data.table_title)">
                                                                    <BIconTranslate />
                                                                </b-btn>
                                                            </template>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </template>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-td>
                        </b-tr>
                    </template>
                    <template v-if="has_sub_data_table_header.kr">
                        <b-tr>
                            <b-td colspan="2">
                                <b-row>
                                    <b-col cols="12">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <h6>테이블 헤더</h6>

                                            <div>
                                                <b-btn variant="warning" size="sm" class="mr-2"
                                                    @click="initTableHeaderTranslation"
                                                    >
                                                    번역 초기화
                                                </b-btn>
                                                <b-btn
                                                    variant="primary" size="sm"
                                                    :disabled="(!has_sub_data_table_header.ea && !has_sub_data_table_header.ca) || !is_edited_table_header"
                                                    @click="emitEditedTableHeaderTitle"
                                                    >
                                                    저장
                                                </b-btn>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-row>
                                            <b-col cols="12" class="mb-1">
                                                <h6 class="f-100">영문</h6>
                                                <template v-if="!has_sub_data_table_header.ea">
                                                    <div class="d-flex align-items-center justify-content-center p-4 bgray-200">
                                                        <h6 class="font-italic gray-500 mb-0">(없음)</h6>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <b-table-simple :id="`sub_code-${sub_code}-table-tableheader-translaton-ea`" bordered class="mb-2">
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th v-for="(header, header_idx) in editable_sub_data.table_header_ea"
                                                                    :key="`sub_code-${sub_code}-table-tableheader-translaton-ea-thead-${header_idx}`"
                                                                    :class="[{ 'gray-500': isFieldEmpty(header.key) }]"
                                                                    >
                                                                    {{ isFieldEmpty(header.key) ? '(없음)' : header.key }}
                                                                </b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr>
                                                                <b-td v-for="(header, header_idx) in editable_sub_data.table_header_ea"
                                                                    :key="`sub_code-${sub_code}-table-tableheader-translaton-ea-tbody-${header_idx}`"
                                                                    >
                                                                    <b-input-group>
                                                                        <b-form-input
                                                                            :id="`${sub_code}-table-header-translation-input-${header_idx}`"
                                                                            v-model="header.label"
                                                                            @input="changeEditingTableHeader"
                                                                            :disabled="isFieldEmpty(sub_data_content.table_header_ea[header_idx]) || isFieldEmpty(sub_data_content.table_header_ea[header_idx].label)"
                                                                            :placeholder="isFieldEmpty(sub_data_content.table_header_ea[header_idx].label) ? '(없음)' : ''"
                                                                            trim
                                                                            />
                                                                    </b-input-group>
                                                                </b-td>
                                                            </b-tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </template>
                                            </b-col>
                                            <b-col cols="12">
                                                <h6 class="f-100">중문</h6>
                                                <template v-if="!has_sub_data_table_header.ca">
                                                    <div class="d-flex align-items-center justify-content-center p-4 bgray-200">
                                                        <h6 class="font-italic gray-500 mb-0">(없음)</h6>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <b-table-simple :id="`sub_code-${sub_code}-table-tableheader-translaton-ca`" bordered class="mb-0">
                                                        <b-thead>
                                                            <b-tr>
                                                                <b-th v-for="(header, header_idx) in editable_sub_data.table_header_ca"
                                                                    :key="`sub_code-${sub_code}-table-tableheader-translaton-ca-thead-${header_idx}`"
                                                                    :class="[{ 'gray-500': isFieldEmpty(header.key) }]"
                                                                    >
                                                                    {{ isFieldEmpty(header.key) ? '(없음)' : header.key }}
                                                                </b-th>
                                                            </b-tr>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <b-tr>
                                                                <b-td v-for="(header, header_idx) in editable_sub_data.table_header_ca"
                                                                    :key="`sub_code-${sub_code}-table-tableheader-translaton-ca-tbody-${header_idx}`"
                                                                    >
                                                                    <b-input-group>
                                                                        <b-form-input
                                                                            :id="`${sub_code}-table-header-translation-input-${header_idx}`"
                                                                            v-model="header.label"
                                                                            @input="changeEditingTableHeader"
                                                                            :disabled="isFieldEmpty(sub_data_content.table_header_ca[header_idx]) || isFieldEmpty(sub_data_content.table_header_ca[header_idx].label)"
                                                                            :placeholder="isFieldEmpty(sub_data_content.table_header_ca[header_idx].label) ? '(없음)' : ''"
                                                                            trim
                                                                            />
                                                                    </b-input-group>
                                                                </b-td>
                                                            </b-tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </template>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </template>
            <template v-if="has_table_title.kr || has_sub_data_table_header.kr">
                <b-thead>
                    <b-tr>
                        <b-th class="text-nowrap"> 행 인덱스 </b-th>
                        <b-th>
                            <div class="d-flex align-items-center justify-content-between">
                                편집 컨텐츠

                                <b-btn variant="primary" size="sm"
                                    @click="emitEditedTableHSubDataContents"
                                    >
                                    저장
                                </b-btn>
                            </div>
                        </b-th>
                    </b-tr>
                </b-thead>
            </template>
            <b-tbody>
                <b-tr v-for="(editable_structure, structure_index) in editable_sub_data_content_structure"
                    :key="`table-${sub_code}-structure-${content_index}-structure-${structure_index}`"
                    >
                    <b-td>
                        {{ structure_index + 1 }}
                    </b-td>
                    <b-td>
                        <b-row>
                            <b-col cols="12">
                                <h6>수정불가 텍스트</h6>
                            </b-col>
                            <b-col cols="12">
                                <template v-if="!table_structure_noteditables_list[structure_index] || !table_structure_noteditables_list[structure_index].length">
                                    <div class="d-flex align-items-center justify-content-center p-4 bgray-200">
                                        <h6 class="font-italic gray-500 mb-0">(없음)</h6>
                                    </div>
                                </template>
                                <template v-else>
                                    <b-row v-for="(noteditables, noteditables_index) in table_structure_noteditables_list[structure_index]"
                                        :key="`table-${sub_code}-sub_data_contents-${content_index}-structure-${structure_index}-noteditable-${noteditables_index}`"
                                        >
                                        <b-col cols="12">
                                            <h6 class="f-100"> 컬럼 이름: {{ noteditables }} </h6>
                                        </b-col>
                                        <b-col cols="12">
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-noteditable-${noteditables_index}`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${noteditables} (국문)`"
                                                :label-for="`input-noteditable-contents-${content_index}-noteditables-${noteditables_index}-kr`"
                                                >
                                                <b-form-input
                                                    :id="`input-noteditable-contents-${content_index}-noteditables-${noteditables_index}-kr`"
                                                    v-model="editable_structure[`${noteditables}`]"
                                                    @input="changeEditingTableSub"
                                                    disabled
                                                    readonly
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12">
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-noteditable-${noteditables_index}-ea`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${noteditables} (영문)`"
                                                :label-for="`input-noteditable-contents-${content_index}-noteditables-${noteditables_index}-ea`"
                                                >
                                                <b-input-group>
                                                    <b-form-input
                                                        :id="`input-noteditable-contents-${content_index}-noteditables-${noteditables_index}-ea`"
                                                        v-model="editable_structure[`${noteditables}_ea`]"
                                                        @input="changeEditingTableSub"
                                                        :disabled="isFieldEmpty(sub_data_content.structure[structure_index][`${noteditables}`])"
                                                        />

                                                    <template #append>
                                                        <b-btn variant="warning" size="sm"
                                                            @click="generateTempTranslation(editable_structure[`${noteditables}`], 'ea')"
                                                            :disabled="isFieldEmpty(editable_structure[`${noteditables}`])">
                                                            <BIconTranslate />
                                                        </b-btn>
                                                    </template>
                                                </b-input-group>
                                                
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12">
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-noteditable-${noteditables_index}-ca`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${noteditables} (중문)`"
                                                :label-for="`input-noteditable-contents-${content_index}-noteditables-${noteditables_index}-ca`"
                                                >
                                                <b-input-group>
                                                    <b-form-input
                                                        :id="`input-noteditable-contents-${content_index}-noteditables-${noteditables_index}-ca`"
                                                        v-model="editable_structure[`${noteditables}_ca`]"
                                                        @input="changeEditingTableSub"
                                                        :disabled="isFieldEmpty(sub_data_content.structure[structure_index][`${noteditables}`])"
                                                        />
                                                    <template #append>
                                                        <b-btn variant="warning" size="sm"
                                                            @click="generateTempTranslation(editable_structure[`${noteditables}`], 'ca')"
                                                            :disabled="isFieldEmpty(editable_structure[`${noteditables}`])">
                                                            <BIconTranslate />
                                                        </b-btn>
                                                    </template>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <hr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h6>입력창 가이드 텍스트 (placeholder)</h6>
                            </b-col>
                            <b-col cols="12">
                                <template v-if="!table_structure_placeholder_list[structure_index]">
                                    <div class="d-flex align-items-center justify-content-center p-4 bgray-200">
                                        <h6 class="font-italic gray-500 mb-0">(없음)</h6>
                                    </div>
                                </template>
                                <template v-else>
                                    <b-row v-for="(placeholder, placeholder_key, placeholder_index) in table_structure_placeholder_list[structure_index]"
                                        :key="`table-${sub_code}-sub_data_contents-${content_index}-structure-${structure_index}-placeholder-${placeholder_index}`"
                                        >
                                        <b-col cols="12">
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-placeholder-${placeholder_key}-ca`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${placeholder_key.split('_')[0]} (${computeTranslationLanguage(placeholder_key)})`"
                                                :label-for="`input-placeholder-contents-${content_index}-structure-${structure_index}-placeholder-${placeholder_key}-kr`"
                                                >
                                                <b-input-group>
                                                    <b-form-input
                                                        :id="`input-placeholder-contents-${content_index}-structure-${structure_index}-placeholder-${placeholder_key}-kr`"
                                                        v-model="editable_structure.placeholder[placeholder_key]"
                                                        @input="changeEditingTableSub"
                                                        :disabled="(!/_ca|_ea$/.test(placeholder_key)) || isFieldEmpty(sub_data_content.structure[structure_index]) || isFieldEmpty(sub_data_content.structure[structure_index].placeholder[placeholder_key])"
                                                        :readonly="(!/_ca|_ea$/.test(placeholder_key)) || isFieldEmpty(sub_data_content.structure[structure_index]) || isFieldEmpty(sub_data_content.structure[structure_index].placeholder[placeholder_key])"
                                                        trim
                                                        />

                                                    <template v-if="/_ca|_ea$/.test(placeholder_key)" #append>
                                                        <b-btn variant="warning" size="sm"
                                                            @click="generateTempTranslation(editable_structure.placeholder[placeholder_key.split('_')[0]], placeholder_key.split('_')[1])"
                                                            :disabled="isFieldEmpty(sub_data_content.structure[structure_index].placeholder[placeholder_key.split('_')[0]])"
                                                            >
                                                            <BIconTranslate />
                                                        </b-btn>
                                                    </template>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <hr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h6>드롭다운 (dropdown)</h6>
                            </b-col>
                            <template v-if="!editable_structure.dropdown || !editable_structure.dropdown.length">
                                <b-col cols="12">
                                    <div class="d-flex align-items-center justify-content-center p-4 bgray-200">
                                        <h6 class="font-italic gray-500 mb-0">(없음)</h6>
                                    </div>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col cols="12" class="mb-4">
                                    <p class="font-weight-bold">선택지</p>
                                    <b-form-group v-for="(_option, _option_index) in editable_structure.dropdown"
                                        :key="`table-${sub_code}-sub_data_contents-${content_index}-structure-${structure_index}-dropdown-${_option_index}`"
                                        :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-dropdown-${_option.key}`"
                                        label-cols-sm="2"
                                        content-cols-sm
                                        content-cols-lg="10"
                                        :label="`${_option.key.replace(/[_ca|_ea]/g, '')} (${computeTranslationLanguage(_option.key)})`"
                                        :label-for="`input-dropdown-${_option_index}-${_option.key}`"
                                        >
                                        <b-input-group>
                                            <b-form-input
                                                :id="`input-dropdown-${_option_index}-${_option.key}`"
                                                v-model="_option.option"
                                                @input="changeEditingTableSub"
                                                :disabled="(!/_ca|_ea$/.test(_option.key)) || isFieldEmpty(sub_data_content.structure[structure_index].dropdown) || isFieldEmpty(sub_data_content.structure[structure_index].dropdown[_option.key])"
                                                :readonly="(!/_ca|_ea$/.test(_option.key)) || isFieldEmpty(sub_data_content.structure[structure_index].dropdown) || isFieldEmpty(sub_data_content.structure[structure_index].dropdown[_option.key])"
                                                trim
                                                />
                                            
                                            <template v-if="/_ca|_ea$/.test(_option.key)" #append>
                                                <b-btn variant="warning" size="sm"
                                                    @click="generateTempTranslation(sub_data_content.structure[structure_index].dropdown[_option.key.replace(/[_ca|_ea]/g, '')], _option.key.split('_')[1])"
                                                    :disabled="isFieldEmpty(sub_data_content.structure[structure_index].dropdown[_option.key.replace(/[_ca|_ea]/g, '')])"
                                                    >
                                                    <BIconTranslate />
                                                </b-btn>
                                            </template>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <hr>
                                </b-col>
                                <b-col cols="12">
                                    <p class="font-weight-bold">기본값</p>
                                    <div v-for="(_header, _header_index) in editable_sub_data.table_header"
                                        :key="`table-${sub_code}-sub_data_contents-${content_index}-structure-${structure_index}-dropdown-${_header_index}-defaultValue`"
                                        >
                                        <template v-if="(editable_sub_data_content_structure[structure_index] && editable_sub_data_content_structure[structure_index][_header]) && (table_structure_noteditables_list[structure_index] && !table_structure_noteditables_list[structure_index].includes(_header))">
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-dropdown-${_header}-defaultValue`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${_header} (국문)`"
                                                :label-for="`input-dropdown-${_header_index}-${_header}-defaultValue`"
                                                >
                                                <b-input-group>
                                                    <b-form-input
                                                        :id="`input-dropdown-${_header_index}-${_header}-defaultValue-ko`"
                                                        v-model="editable_sub_data_content_structure[structure_index][_header]"
                                                        disabled readonly trim
                                                        />
                                                </b-input-group>
                                            </b-form-group>
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-dropdown-${_header}-defaultValue-ea`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${_header} (영문)`"
                                                :label-for="`input-dropdown-${_header_index}-${_header}-defaultValue-ea`"
                                                >
                                                <b-input-group>
                                                    <b-form-input
                                                        :id="`input-dropdown-${_header_index}-${_header}-defaultValue-ea`"
                                                        v-model="editable_sub_data_content_structure[structure_index][`${_header}_ea`]"
                                                        trim
                                                        />
                                                    
                                                    <b-btn variant="warning" size="sm"
                                                        @click="generateTempTranslation(editable_sub_data_content_structure[structure_index][_header], 'ea')"
                                                        :disabled="isFieldEmpty(editable_sub_data_content_structure[structure_index][_header])"
                                                        >
                                                        <BIconTranslate />
                                                    </b-btn>
                                                </b-input-group>
                                            </b-form-group>
                                            <b-form-group
                                                :id="`fieldset-${sub_code}-table-contents-${content_index}-structure-${structure_index}-dropdown-${_header}-defaultValue-ca`"
                                                label-cols-sm="2"
                                                content-cols-sm
                                                content-cols-lg="10"
                                                :label="`${_header} (중문)`"
                                                :label-for="`input-dropdown-${_header_index}-${_header}-defaultValue-ca`"
                                                >
                                                <b-input-group>
                                                    <b-form-input
                                                        :id="`input-dropdown-${_header_index}-${_header}-defaultValue-ca`"
                                                        v-model="editable_sub_data_content_structure[structure_index][`${_header}_ca`]"
                                                        trim
                                                        />
                                                    
                                                    <b-btn variant="warning" size="sm"
                                                        @click="generateTempTranslation(editable_sub_data_content_structure[structure_index][_header], 'ca')"
                                                        :disabled="isFieldEmpty(editable_sub_data_content_structure[structure_index][_header])"
                                                        >
                                                        <BIconTranslate />
                                                    </b-btn>
                                                </b-input-group>
                                            </b-form-group>
                                        </template>
                                    </div>
                                </b-col>
                            </template>
                        </b-row>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { debounce } from 'lodash';
import { computeTranslationLanguage } from '@core_utils/subComponent/subComponent';

export default {
    name: 'editing-translation-table',
    mixins: [],
    props: {
        sub_type: {
            type: String,
            default: 'table'
        },
        sub_code: {
            type: String,
            default: ''
        },
        sub_data_content: {
            type: Object
        },
        content_index: {
            type: Number,
            default: 0
        },
        element_index: {
            type: Number,
            default: 0
        },
        is_element: {
            type: Boolean,
            default: false
        },
        request_edited_table_subData: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            has_table_translation: null,
            is_edited_table_structure: false,
            is_edited_table_header: false,
            is_edited_table_title: false,
            editable_sub_data: {},
            editable_sub_data_content_structure: [],
            table_structure_noteditables_list: null,
            table_structure_placeholder_list: null
        }
    },
    computed: {
        has_sub_data_table_header () {
            const { table_header, table_header_ea, table_header_ca } = this.editable_sub_data
			let headerGroup = { kr: true, ea: true, ca: true }

			if (this.isFieldEmpty(table_header)) {
				headerGroup.kr = false
			}

			if (!this.isFieldEmpty(table_header) && this.isFieldEmpty(table_header_ea)) {
				headerGroup.ea = false
			}

			if (!this.isFieldEmpty(table_header) && this.isFieldEmpty(table_header_ca)) {
				headerGroup.ca = false
			}
            
			return headerGroup
		},
        has_table_title () {
            const { table_title, table_title_ea, table_title_ca } = this.editable_sub_data
			let titleGroup = { kr: true, ea: true, ca: true }

			if (this.isFieldEmpty(table_title)) {
				titleGroup.kr = false
			}

			if (!this.isFieldEmpty(table_title) && this.isFieldEmpty(table_title_ea)) {
				titleGroup.ea = false
			}

			if (!this.isFieldEmpty(table_title) && this.isFieldEmpty(table_title_ca)) {
				titleGroup.ca = false
			}
            
			return titleGroup
		}
    },
    watch: {
        sub_data_content (_update_sub_data) {
            if (_update_sub_data) {
                this.generate_editable_sub_data(_update_sub_data)
                this.has_table_translation = this.validate_table_translation()
            }
        },
        is_edited_table_structure (_edited_status) {
            this.$emit('emit_is_edited_table', {
                is_element: this.is_element,
                edited_status: _edited_status
            })
        },
        has_table_translation (_has_status) {
            this.$emit('emit_has_table_translation', {
                sub_code: this.sub_code,
                content_index: this.content_index,
                element_index: this.element_index,
                is_element: this.is_element,
                has_status: _has_status
            })
        },
        request_edited_table_subData (_is_request) {
            if (_is_request) {
                this.$emit('send_edited_table_subDataContens', this.convert_edited_sub_data())
            }
        }
    },
    created () {
        this.generate_editable_sub_data()
    },
    mounted () {
        this.has_table_translation = this.validate_table_translation()
    },
    beforeDestroy () {
        this.has_table_translation = null
        this.is_edited_table_structure = false
        this.is_edited_table_header = false
        this.is_edited_table_title = false
        this.editable_sub_data = {}
        this.editable_sub_data_content_structure = []
        this.table_structure_noteditables_list = null
        this.table_structure_placeholder_list = null
    },
    methods: {
        computeTranslationLanguage,
        async initTableHeaderTranslation () {
            let _table_header_ea = this.sub_data_content.table_header.reduce((_table_header_ea, _table_header_kr) => {
                _table_header_ea.push({ key: _table_header_kr, label: null })
                return _table_header_ea
            }, [])
            
            let _table_header_ca = this.sub_data_content.table_header.reduce((_table_header_ca, _table_header_kr) => {
                _table_header_ca.push({ key: _table_header_kr, label: null })
                return _table_header_ca
            }, [])

            for await (let _header_ca of _table_header_ca) {
                if (_header_ca.key) {
                    const _res_translated = await this.$axios.post("/translate", {
                        target_lang: 'zh-cn', text: _header_ca.key
                    })
                    _header_ca.label = _res_translated.data
                } else {
                    _header_ca.label = _header_ca.key
                }
            }

            for await (let _header_ea of _table_header_ea) {
                if (_header_ea.key) {
                    const _res_translated = await this.$axios.post("/translate", {
                        target_lang: 'en-US', text: _header_ea.key
                    })

                    _header_ea.label = _res_translated.data
                } else {
                    _header_ea.label = _header_ea.key
                }
            }

            const saving_data = this.convert_edited_sub_data()
            saving_data["table_header_ea"] = _table_header_ea
            saving_data["table_header_ca"] = _table_header_ca
            
            this.$emit('send_edited_table_subDataContens', saving_data)
            this.is_edited_table_header = false
            this.is_edited_table_title = false

            if (this.is_edited_table_structure && is_confirm_save_edited_table_structure) {
                this.is_edited_table_structure = false
            }
        },
        generate_editable_sub_data (sub_data_content = this.sub_data_content) {
            if (sub_data_content) {
                const _table_sub_data = JSON.stringify(sub_data_content)
                const _editable_sub_data = JSON.parse(_table_sub_data)

                const _table_sub_data_structure = JSON.stringify(sub_data_content.structure)
                const _editable_sub_data_content_structure = JSON.parse(_table_sub_data_structure)
                
                this.editable_sub_data = _editable_sub_data
                this.editable_sub_data_content_structure = _editable_sub_data_content_structure.reduce((_editable_structures, _editable_structure) => {
                    if (!this.isFieldEmpty(_editable_structure.dropdown)) {
                        const dropdown_key_kr_list = Object.keys(_editable_structure.dropdown).filter((key) => !/_ca|_ea$/.test(key))
                        if (dropdown_key_kr_list.length) {
                            _editable_structure.dropdown = dropdown_key_kr_list.reduce((joinedOption, _option_kr) => {
                                const _kr_option = _editable_structure.dropdown[_option_kr],
                                      _ea_option = _editable_structure.dropdown[`${_option_kr}_ea`],
                                      _ca_option = _editable_structure.dropdown[`${_option_kr}_ca`]
                                
                                if (_kr_option) {
                                    joinedOption.push({ key: _option_kr, option: _kr_option.join(',') })
                                }

                                if (_kr_option && _ea_option) {
                                    joinedOption.push({ key: `${_option_kr}_ea`, option: _ea_option.join(',') })
                                } else if (_kr_option && !_ea_option) {
                                    joinedOption.push({ key: `${_option_kr}_ea`, option: null })
                                }

                                if (_kr_option && _ca_option) {
                                    joinedOption.push({ key: `${_option_kr}_ca`, option: _ca_option.join(',') })
                                } else if (_kr_option && !_ca_option) {
                                    joinedOption.push({ key: `${_option_kr}_ca`, option: null })
                                }
                                return joinedOption
                            }, [])
                        }

                        _editable_structure.dropdown = _editable_structure.dropdown.sort((b, a) => b.key - a.key)
                    } else {
                        _editable_structure.dropdown = null
                    }
                    
                    _editable_structures.push(_editable_structure)
                    return _editable_structures 
                }, [])

                this.generate_table_structure_noteditables()
                this.generate_table_structure_placeholder()
            }
        },
        generate_table_structure_noteditables () { 
            if (this.sub_type === 'table' && this.editable_sub_data_content_structure) {
                this.table_structure_noteditables_list = this.editable_sub_data_content_structure.reduce((_structure_noteditables, _structure) => {
                    if (_structure.noteditables && _structure.noteditables.length) {
                        const _noteditables = [...new Set(_structure.noteditables)]
                        _structure_noteditables.push(_noteditables)
                    } else {
                        _structure_noteditables.push(null)
                    }
                    return _structure_noteditables
                }, [])
            } else {
                this.table_structure_noteditables_list = null
            }
        },
        generate_table_structure_placeholder () {
            if (this.sub_type === 'table' && this.editable_sub_data_content_structure) {
                this.table_structure_placeholder_list = this.editable_sub_data_content_structure.reduce((_structure_placeholderes, _structure) => {
                    if (_structure.placeholder && Object.keys(_structure.placeholder).length) {
                        _structure_placeholderes.push(_structure.placeholder)
                    } else {
                        _structure_placeholderes.push(null)
                    }
                    return _structure_placeholderes
                }, [])
            } else {
                this.table_structure_placeholder_list = null
            }
        },
        changeEditingTableSub: debounce(function () {
            this.is_edited_table_structure = this.sub_data_content.structure.reduce((_is_table_structure_edited, _structure, _structure_idx) => {
                const _editable_structure = this.editable_sub_data_content_structure[_structure_idx]
                if (!_is_table_structure_edited && !this.isFieldEmpty(this.table_structure_noteditables_list[_structure_idx])) { 
                    _is_table_structure_edited = this.table_structure_noteditables_list[_structure_idx].reduce((_is_noteditable_edited, noteditable) => {
                        if (!_is_noteditable_edited) {
                            _is_noteditable_edited = _structure[noteditable] !== _editable_structure[noteditable]
                        }

                        if (!_is_noteditable_edited) {
                            _is_noteditable_edited = _structure[`${noteditable}_ea`] !== _editable_structure[`${noteditable}_ea`]
                        }

                        if (!_is_noteditable_edited) {
                            _is_noteditable_edited = _structure[`${noteditable}_ca`] !== _editable_structure[`${noteditable}_ca`]
                        }
                        return _is_noteditable_edited
                    }, false)
                }

                if (!_is_table_structure_edited && !this.isFieldEmpty(this.table_structure_placeholder_list[_structure_idx])) {
                    _is_table_structure_edited = Object.entries(this.table_structure_placeholder_list[_structure_idx])
                        .reduce((_is_placeholder_edited, [placeholderKey, placeholder]) => {
                            if (!_is_placeholder_edited && !this.isFieldEmpty(placeholder)) {
                                if (!_is_placeholder_edited) {
                                    _is_placeholder_edited = _structure.placeholder[placeholderKey] !== placeholder
                                }

                                if (!_is_placeholder_edited) {
                                    _is_placeholder_edited = _structure.placeholder[`${placeholderKey}_ea`] !== _editable_structure.placeholder[`${placeholderKey}_ea`]
                                }

                                if (!_is_placeholder_edited) {
                                    _is_placeholder_edited = _structure.placeholder[`${placeholderKey}_ca`] !== _editable_structure.placeholder[`${placeholderKey}_ca`]
                                }
                            }
                            return _is_placeholder_edited
                        }, false)
                }

                if (!_is_table_structure_edited && !this.isFieldEmpty(_editable_structure.dropdown)) {
                    _is_table_structure_edited = _editable_structure.dropdown.reduce((_is_structure_dropdown_edited, dropdown) => {
                        if (!_is_structure_dropdown_edited && !this.isFieldEmpty(_structure.dropdown[dropdown.key])) {
                            _is_structure_dropdown_edited = _structure.dropdown[dropdown.key].join(',').trim().replace(/(\s*)/g,"") !== dropdown.option.trim().replace(/(\s*)/g,"")
                        }

                        return _is_structure_dropdown_edited
                    }, false)
                }

                return _is_table_structure_edited
            }, false)

            this.has_table_translation = this.validate_table_translation()
            
        }, 500),
        changeEditingTableHeader: debounce(function () {
            this.is_edited_table_header = this.sub_data_content.table_header_ea.reduce((_is_edited_table_header_ea, header_ea, header_ea_idx) => {
                if (!_is_edited_table_header_ea) {
                    if (!_is_edited_table_header_ea) {
                        _is_edited_table_header_ea = header_ea.label !== this.editable_sub_data.table_header_ea[header_ea_idx].label
                    }
                }
                return _is_edited_table_header_ea
            }, false)

            if (!this.is_edited_table_header) {
                this.is_edited_table_header = this.sub_data_content.table_header_ca.reduce((_is_edited_table_header_ca, header_ca, header_ca_idx) => {
                    if (!_is_edited_table_header_ca) {
                        _is_edited_table_header_ca = header_ca.label !== this.editable_sub_data.table_header_ca[header_ca_idx].label
                    }
                    return _is_edited_table_header_ca
                }, false)
            }

            this.has_table_translation = this.validate_table_translation()
        }, 500),
        chageEditingTableTitle: debounce(function () {
            this.is_edited_table_title = (
                this.sub_data_content.table_title_ca !== this.editable_sub_data.table_title_ca
                ||
                this.sub_data_content.table_title_ea !== this.editable_sub_data.table_title_ea
            )

            this.has_table_translation = this.validate_table_translation()
        }, 500),
        emitEditedTableHeaderTitle () {
            if (this.is_edited_table_header || this.is_edited_table_title) {
                let saving_data = null
                let is_confirm_save_edited_table_structure = null

                if (this.is_edited_table_structure) {
                    is_confirm_save_edited_table_structure = confirm('편집된 테이블 컨텐츠가 있습니다. 함께 저장하시겠습니까?')
                }
                if (is_confirm_save_edited_table_structure) {
                    saving_data = this.convert_edited_sub_data()
                } else {
                    // 표 구조를 함께 저장하지 않더라도 제목/헤더 번역은 저장한다
                    saving_data = this.convert_edited_sub_data()
                    saving_data = {
                        content_index: saving_data.content_index,
                        element_index: saving_data.element_index,
                        is_element: saving_data.is_element,
                        table_header_ea: saving_data.table_header_ea,
                        table_header_ca: saving_data.table_header_ca,
                        table_title_ea: saving_data.table_title_ea,
                        table_title_ca: saving_data.table_title_ca
                    }
                }

                if (saving_data) {
                    this.$emit('send_edited_table_subDataContens', saving_data)
                }

                this.is_edited_table_header = false
                this.is_edited_table_title = false

                if (this.is_edited_table_structure && is_confirm_save_edited_table_structure) {
                    this.is_edited_table_structure = false
                }
            }
        },
        emitEditedTableHSubDataContents () {
            let saving_data = null
            let is_confirm_save_edited_table_structure = null

            if (this.is_edited_table_structure) {
                is_confirm_save_edited_table_structure = confirm('편집된 테이블 컨텐츠가 있습니다. 함께 저장하시겠습니까?')
                // 취소하면 아무것도 보내지 않았으므로 변경 표시도 지우지 않는다
                if (!is_confirm_save_edited_table_structure) return
                saving_data = this.convert_edited_sub_data()
            } else {
                saving_data = this.convert_edited_sub_data()
                const {
                    content_index, element_index, is_element,
                    edited_sub_data_contents_structure
                } = saving_data

                saving_data = {
                    content_index, element_index, is_element,
                    edited_sub_data_contents_structure
                }
            }

            if (saving_data) {
                this.$emit('send_edited_table_subDataContens', { ...saving_data })
            }

            this.is_edited_table_header = false
            this.is_edited_table_title = false

            if (this.is_edited_table_structure && is_confirm_save_edited_table_structure) {
                this.is_edited_table_structure = false
            }
            
        },
        convert_edited_sub_data () {
            let _edited_sub_data_contents_structure = JSON.stringify(this.editable_sub_data_content_structure)
            _edited_sub_data_contents_structure = JSON.parse(_edited_sub_data_contents_structure)
            
            const edited_sub_data_contents_structure = _edited_sub_data_contents_structure.reduce((_edited_structures, _edited_structure) => {
                if (_edited_structure.dropdown && _edited_structure.dropdown.length) {
                    _edited_structure.dropdown = _edited_structure.dropdown.reduce((editedOptionObj, editedOption) => {
                        if (!editedOptionObj[editedOption.key] && !this.isFieldEmpty(editedOption.option)) {
                            editedOptionObj[editedOption.key] = editedOption.option.split(', ')
                        }
                        return editedOptionObj
                    }, {})
                } else {
                    _edited_structure.dropdown = {}
                }
                
                _edited_structures.push(_edited_structure)
                return _edited_structures 
            }, [])

            return {
                content_index: this.content_index,
                element_index: this.element_index,
                is_element: this.is_element,
                edited_sub_data_contents_structure,
                table_header_ea: this.editable_sub_data.table_header_ea,
                table_header_ca: this.editable_sub_data.table_header_ca,
                table_title_ea: this.editable_sub_data.table_title_ea,
                table_title_ca: this.editable_sub_data.table_title_ca
            }
        },
        validate_table_translation () {
            if (this.sub_type === 'table' && this.editable_sub_data) {
				let has_tranlation_table_structure = true

                // 테이블 헤더 번역 검증
				const { table_header, table_header_ea, table_header_ca } = this.editable_sub_data

                if (!this.isFieldEmpty(table_header) && (this.isFieldEmpty(table_header_ea) || this.isFieldEmpty(table_header_ca))) {
                    has_tranlation_table_structure = false
                } else {
                    has_tranlation_table_structure = table_header.reduce((_has_table_header_translation, _header_kr) => {
                        const _header_ea = table_header_ea.find(({ key }) => key === _header_kr)
                        const _header_ca = table_header_ca.find(({ key }) => key === _header_kr)
                        if (_has_table_header_translation && !this.isFieldEmpty(_header_kr) && (this.isFieldEmpty(_header_ea.label) || this.isFieldEmpty(_header_ca.label))) {
                            _has_table_header_translation = false
                        }
                        return _has_table_header_translation
                    }, true)
                }

                // 테이블 타이블(라벨) 번역 검증
                const { table_title, table_title_ea, table_title_ca } = this.editable_sub_data
                if (!this.isFieldEmpty(table_title) && (this.isFieldEmpty(table_title_ea) || this.isFieldEmpty(table_title_ca))) {
                    has_tranlation_table_structure = false
                }
                
                // 테이블 행별 데이터 검증
                if (has_tranlation_table_structure) {
                    has_tranlation_table_structure = this.sub_data_content.structure.reduce((_has_tranlation_table_structure, _structure, _structure_idx) => {
                        const _editable_structure = this.editable_sub_data_content_structure[_structure_idx]

                        // noteditables
                        if (_has_tranlation_table_structure && !this.isFieldEmpty(this.table_structure_noteditables_list[_structure_idx])) {
                            _has_tranlation_table_structure = this.table_structure_noteditables_list[_structure_idx].reduce((_has_noteditable, noteditable) => {
                                if (_has_noteditable && !this.isFieldEmpty(_structure[noteditable]) && this.isFieldEmpty(_structure[`${noteditable}_ea`])) {
                                    _has_noteditable =  false
                                }

                                if (_has_noteditable && !this.isFieldEmpty(_structure[noteditable]) && this.isFieldEmpty(_structure[`${noteditable}_ca`])) {
                                    _has_noteditable =  false
                                }
                                return _has_noteditable
                            }, true)
                        }

                        // placeholder
                        if (_has_tranlation_table_structure && !this.isFieldEmpty(this.table_structure_placeholder_list[_structure_idx])) {
                            const _placeholder_kr = Object.keys(this.table_structure_placeholder_list[_structure_idx]).reduce((_placeholders_kr, _placeholder_key) => {
                                _placeholders_kr.add(_placeholder_key.replace(/_ca|_ea/, ''))
                                return _placeholders_kr
                            }, new Set())

                            _has_tranlation_table_structure = [ ..._placeholder_kr ].reduce((_has_placeholder, placeholderKey) => {
                                if (_has_placeholder && !this.isFieldEmpty(_structure.placeholder[placeholderKey]) && this.isFieldEmpty(_editable_structure.placeholder[`${placeholderKey}_ea`])) {
                                    _has_placeholder = false
                                }

                                if (_has_placeholder && !this.isFieldEmpty(_structure.placeholder[placeholderKey]) && this.isFieldEmpty(_editable_structure.placeholder[`${placeholderKey}_ca`])) {
                                    _has_placeholder = false
                                }
                                return _has_placeholder
                            }, true)
                        }

                        // dropdown
                        if (_has_tranlation_table_structure && !this.isFieldEmpty(_editable_structure.dropdown) && !this.isFieldEmpty(this.editable_sub_data.table_header)) {
                            _has_tranlation_table_structure = this.editable_sub_data.table_header.reduce((_has_structure_dropdown, _header_field) => {
                                const _header_field_dropdown_kr = _structure.dropdown[_header_field]
                                const _header_field_dropdown_ea = _structure.dropdown[`${_header_field}_ea`]
                                const _header_field_dropdown_ca = _structure.dropdown[`${_header_field}_ca`]
                                
                                if (_has_structure_dropdown && !this.isFieldEmpty(_header_field_dropdown_kr) && this.isFieldEmpty(_header_field_dropdown_ea)) {
                                    _has_structure_dropdown = false
                                }

                                if (_has_structure_dropdown && !this.isFieldEmpty(_header_field_dropdown_kr) && this.isFieldEmpty(_header_field_dropdown_ca)) {
                                    _has_structure_dropdown = false
                                }

                                return _has_structure_dropdown
                            }, true)
                        }

                        return _has_tranlation_table_structure
                    }, true)
                }

				return has_tranlation_table_structure
			} else {
				return true
			}
		},
        async generateTempTranslation(kr, lang) {
            const lang_codes = {'zh-cn': 'ca', 'en-US': "ea"}
            
			const _res_translated = await this.$axios.get("/translate", {
                params: { target_lang: lang_codes[lang] ?? lang, text: kr }
            })
			prompt("Ctrl+C를 눌러 복사 후 메모장 에서 확인 또는 바로 번역 입력란에 붙여넣기 하세요.", _res_translated.data);
		}
    }
}
</script>

<style>

</style>
